import monitorLinks from './monitorLinks';

export default monitorLinks;
